import { render, staticRenderFns } from "./IncomePie.vue?vue&type=template&id=42cca58c&"
import script from "./IncomePie.vue?vue&type=script&lang=js&"
export * from "./IncomePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IncomePie.vue"
export default component.exports